import isTurkeyDestAndUser from '@resources/js/helpers/isTurkeyDestAndUser';
export const getBcomOrExpediaPartnerType = () => isTurkeyDestAndUser() ? 'expedia' : 'bcom';
